// @ts-ignore - StickySidebar has no type declarations
import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar'
import { axios } from '@app-bootstrap/axios.bootstrap'
import { bugsnagClient } from '@app-bootstrap/bugsnag.bootstrap'
import { EventData } from '../../algolia/algolia.types'

export function createStickyRightSidebarComponent(container: HTMLElement) {
    return new StickySidebar(container, {
        containerSelector: '#catalog-detail-container',
        innerWrapperSelector: '.sidebar__inner',
        topSpacing: 80,
        bottomSpacing: 80,
        minWidth: 1023,
    })
}

/**
 * Sends data to the server for generating an Algolia event.
 *
 * @param eventData - The data needed for the backend to create the Algolia event.
 */
export function sendAlgoliaEvent(eventData: EventData): void {
    axios.post('/algolia/save-event', { event: eventData })
        .then(() => {
            // Response not needed
        })
        .catch((error) => {
            bugsnagClient.notify(error)
        })
}

/**
 * Retrieves Algolia event data from local storage.
 *
 * @returns The Algolia event data or null if not found.
 */
export function getAlgoliaEventDataFromLocalStorage(): EventData | null {
    const eventDataString = localStorage?.getItem('algoliaEventData')
    if (eventDataString) {
        return JSON.parse(eventDataString)
    }
    return null
}
